import { render } from "./ActiveCheckbox.vue?vue&type=template&id=5f739bd4"
import script from "./ActiveCheckbox.vue?vue&type=script&lang=js"
export * from "./ActiveCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__